import { render, staticRenderFns } from "./salary-panel.vue?vue&type=template&id=db414426&"
import script from "./salary-panel.vue?vue&type=script&lang=js&"
export * from "./salary-panel.vue?vue&type=script&lang=js&"
import style0 from "./salary-panel.vue?vue&type=style&index=0&id=db414426&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports